import { MoreOutlined } from '@ant-design/icons';
import NiceModal from '@ebay/nice-modal-react';
import { useSelector } from 'react-redux';

import { UiPopover } from 'shared/ui';

import {
  checkControllerRight,
  selectTokenClaims,
  selectTokenRoles,
} from 'entities/authorization';
import {
  ChargePointManualCommandType,
  CHARGE_POINT_MANUAL_COMMAND_TYPE,
} from 'entities/manual-command';

import { ManualCommandModal } from 'features/manual-command';

import { PopoverButtonsContainer } from '../../../../common-styles';

type Props = {
  chargePointName: string;
};

export function ChargePointTableActions({ chargePointName }: Props) {
  const roles = useSelector(selectTokenRoles);
  const claims = useSelector(selectTokenClaims);

  const hasRight = checkControllerRight(
    'PrivateMethods',
    'Execute',
    roles,
    claims
  );

  if (!hasRight) {
    return null;
  }

  const showManualCommandModal = (type: ChargePointManualCommandType) => {
    NiceModal.show(ManualCommandModal, {
      commandType: type,
      chargePointName,
    });
  };

  const manualCommands = (
    Object.keys(CHARGE_POINT_MANUAL_COMMAND_TYPE) as unknown as Array<
      keyof typeof CHARGE_POINT_MANUAL_COMMAND_TYPE
    >
  ).map((type) => {
    return (
      <button
        key={CHARGE_POINT_MANUAL_COMMAND_TYPE[type]}
        onClick={() => {
          showManualCommandModal(type);
        }}
      >
        {CHARGE_POINT_MANUAL_COMMAND_TYPE[type]}
      </button>
    );
  });

  const content = (
    <>
      <PopoverButtonsContainer>{manualCommands}</PopoverButtonsContainer>
    </>
  );

  return (
    <UiPopover content={content} children={<MoreOutlined rotate={90} />} />
  );
}
